import { Dialog, DialogContent, DialogDescription, DialogHeader } from "@/components/ui/dialog";
import { ContentCrud } from "@/pages/content/ContentCrud";

export const PlayerContentSelect: React.FC<{
  defaultScreenSizeGuid?: string;
  onChange: (intId: number) => void;
  onOpenChange: (open: boolean) => void;
}> = ({ onChange, onOpenChange, defaultScreenSizeGuid }) => {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] h-[90vh] overflow-y-auto" showClose={false}>
        <DialogHeader>
          <DialogDescription>
            <ContentCrud
              selectConfig={{
                types: [
                  "image",
                  "video",
                  "audio",
                  "fromTemplate",
                  "split",
                  "link",
                  "doc",
                  "link",
                  "dynamic/fromTemplate",
                ],
                onSelect: ({ contentIntId }) => {
                  onChange(contentIntId);
                },
                defaultScreenSizeGuid,
              }}
            />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
